import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { socialTrackEvents } from 'src/common/page-share/page-share.constants';
import { SocialName } from 'src/common/page-share/page-share.types';
import { useSocialLinks } from 'src/common/page-share/use-social-links';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledSocialButton } from 'src/common/styles';
import type { SegmentShareEvent } from 'src/common/types';
import { StyledWrapperButtons } from './big-streak-social-share.styles';
import type { BigStreakSocialShareProps } from './big-streak-social-share.types';
export const BigStreakSocialSharing = ({
  username,
  streakLength,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.facebook]: true,
    [SocialName.linkedin]: true
  }
}: BigStreakSocialShareProps) => {
  const filteredLinks = useSocialLinks(socialLinks);
  const streakUrl = `https://tryhackme.com/${username!}/streaks/${streakLength}-day-streak`;
  const [trackEvent] = useTrackEventMutation();
  const location = useLocation();
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        page: location.pathname,
        achievement: 'streak',
        medium: source,
        clicked_on: source,
        name: 'streak'
      }
    });
  }, [trackEvent, location.pathname]);
  return <StyledWrapperButtons data-sentry-element="StyledWrapperButtons" data-sentry-component="BigStreakSocialSharing" data-sentry-source-file="big-streak-social-share.tsx">
      {filteredLinks.map(social => <StyledSocialButton key={social.name} data-social={social.name} href={social.href({
      description: 'Learning streak in full swing!',
      url: streakUrl,
      campaign: {
        utmContent: 'streak'
      }
    })} target="_blank" onClick={() => trackShareClick(socialTrackEvents[social.name])}>
          <social.icon />
          {social.officialName}
        </StyledSocialButton>)}
    </StyledWrapperButtons>;
};